<template>
  <div class="invalideGoods">
    <div class="inv-header">
      <h3>{{TLang('失效商品','orderConfirm')}}({{ invalideGoods.length }})</h3>
      <div @click="onClickClear">
        {{TLang('清空','list')}}
      </div>
    </div>
    <div class="goods-wrap">
      <el-row
        v-for="goods in invalideGoods"
        :key="goods.id"
        class="goods-item"
      >
        <GoodsItem
          :goods="goods"
          invalide
          :onDelGoods="clearOne"
        />
      </el-row>
    </div>
    <Dialog
      title=" "
      :visible.sync="delDialogVisible"
      width="420px"
      custom-class="shopping-dialog"
      center
      top="50vh"
      @open="delDialogVisible = true"
    >
      <img :src="require('../../../assets/images/delete.png')" />
      <div class="title">
        {{TLang('您要清空失效商品吗','list')}}
      </div>
      <div class="btns">
        <button
          class="close-btn primary"
          @click="onClear"
        >
          {{TLang('清空','list')}}
        </button>
        <button
          class="buy-btn"
          @click="delDialogVisible = false"
        >
          {{TLang('不清空','list')}}
        </button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { Dialog } from 'element-ui';
import GoodsItem from './../MerchantRow/goodsItem';
export default {
  name: 'InvalideGoods',
  components: { Dialog, GoodsItem },
  props: {
    invalideGoods: Array,
    clearAll: Function,
    clearOne: Function,
  },
  data() {
    return {
      delDialogVisible: false,
      deletePopVisible: false,
    };
  },
  methods: {
    onClear() {
      this.delDialogVisible = false;
      this.clearAll();
    },
    onClickClear(){
      this.delDialogVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.invalideGoods {
  .inv-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
    h3 {
      font-size: 20px;
      font-weight: bold;
      color: rgba(17, 17, 17, 1);
      line-height: 50px;
    }
    div {
      width: 64px;
      height: 28px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      border: 1px solid rgba(229, 229, 229, 1);
      line-height: 28px;
      text-align: center;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
      cursor: pointer;
    }
  }
  .goods-wrap {
    border: 1px solid rgba(229, 229, 229, 1);
    // background: #e5e5e5;
    .goods-item {
      padding: 15px 0;
      .dis-text {
        span {
          display: inline-block;
          width: 32px;
          height: 24px;
          background: rgba(247, 247, 247, 1);
          border-radius: 10px;
          font-size: 12px;
          font-weight: 500;
          color: rgba(178, 178, 178, 1);
          line-height: 24px;
          text-align: center;
          margin-left: 6px;
        }
        img {
          width: 90px;
          height: 90px;
          border: 1px solid rgba(240, 240, 240, 1);
          margin-left: 12px;
        }
      }

      .goods-name {
        h4 {
          font-size: 14px;
          color: rgba(17, 17, 17, 1);
        }
        span {
          font-size: 12px;
          color: rgba(153, 153, 153, 1);
          margin-top: 5px;
          display: inline-block;
          line-height: 24px;
        }
        .reason {
          font-size: 14px;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
  }
  /deep/ .shopping-dialog {
    transform: translateY(-50%);
    text-align: center;
    /deep/ .el-dialog__header {
      padding: 0;
      .el-dialog__headerbtn {
        font-size: 24px;
        top: 15px;
      }
    }
    /deep/ .el-dialog__body {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .title {
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
        line-height: 24px;
      }
      .btns {
        margin-top: 30px;
        button {
          width: 120px;
          height: 40px;
          border-radius: 4px;
          font-size: 14px;
          font-weight: bold;
          text-align: center;
          line-height: 40px;
          &:hover {
            cursor: pointer;
          }
        }
        .close-btn {
          border: 1px solid rgba(229, 229, 229, 1);
          color: #999;
          margin-right: 30px;
          width: auto;
          min-width: 120px;
        }
        .primary {
          background: linear-gradient(
            315deg,
            rgba(92, 180, 236, 1) 0%,
            rgba(61, 150, 226, 1) 100%
          );
          border-radius: 4px;
          color: #fff;
        }
      }
    }
  }
}
</style>
